<template>
    <div>
        <div class="entete border-entete">
            <div class="level">
              <div class="level-left">
                <div class="columns is-gapless">
                  <div class="column">
                      <h1 class="title is-size-3">
                          {{ $t("listeLignesDevis.title") }}
                      </h1>
                      <app-breadcrumb :breadcrumb="breadcrumb"/>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <tabListeLignesDevis class="mgt-20px"></tabListeLignesDevis>
    </div>
</template>

<script>
import tabListeLignesDevis from '@/components/bodac/lignesDevis/tabListeLignesDevis';
import AppBreadcrumb from '@/components/general/breadcrumb';

export default {
  data() {
    return {
    };
  },
  components: {
    tabListeLignesDevis,
    AppBreadcrumb,
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeLignesDevis.title'), route: { name: '' }, isActive: true },
      ];
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageGescom.lignesDevis.listeLigneDvs'));
  },
};
</script>
